import './BleConnect.css';
import BleChannel from 'components/channel/BleChannel';
import ChannelsService from 'data/ChannelsService';
import React from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';


const State = Object.freeze({
  BROWSER_NOT_SUPPORTED: 'State.BROWSER_NOT_SUPPORTED',
  IDLE: 'State.IDLE',
  SCANNING: 'State.SCANNING',
});


class BleConnect extends React.Component {
  constructor(...args) {
    super(...args);
    this.channelsService = new ChannelsService.Factory().create();
    this.idleLabel = this.props.label;
    this.serviceName = this.props.serviceName;
    this.state = { scanState: State.IDLE, dialogVisible: true, };
  }

  beginScan() {
    if (!navigator.bluetooth) {
      this.setState({ scanState: State.BROWSER_NOT_SUPPORTED });
      return;
    }
    this.setState({ scanState: State.SCANNING });
    navigator.bluetooth.requestDevice(
        { filters: [ { services : [ this.serviceName ] } ] })
      .then(this.connect.bind(this))
      .catch(error => {
        console.log(error);
        console.log(error.message);
        this.setState({ scanState: State.IDLE });
      });
  }

  connect(device) {
    const channel = new BleChannel(device, '00002a37', 2000);
    this.channelsService.add(channel.getId(), channel);
    this.setState({ scanState: State.IDLE });
  }

  render() {
    let content;
    switch (this.state.scanState) {
      case State.IDLE:
        content = (
            <Button
                icon='pi pi-plus'
                label={this.props.label}
                onClick={this.beginScan.bind(this)} />);
        break;
      case State.SCANNING:
        content = <Button label='Scanning…' disabled='disabled' />;
        break;
      case State.BROWSER_NOT_SUPPORTED:
        content = (
          <div>
            <Dialog 
                header='Browser not supported'
                visible={this.state.dialogVisible}
                style={{width: '50vw'}}
                modal={true}
                onHide={() => this.setState({dialogVisible: false})}>
              Only Chrome is supported for this demo.
            </Dialog>
            <Button label='Scan' disabled='disabled' />
          </div>);
        break;
      default:
        content = `Unknown state (${this.props.state}).`;
    }
    return <div className='BleConnect'>{content}</div>;
  }
}

export default BleConnect;

